<template>
  <ul class="structurizer-menu">
    <NestedMenuItem v-for="item in page.structurizer" :key="item.id" :item="item" />
  </ul>
</template>

<script setup>
import NestedMenuItem from "./NestedMenuItem.vue";
const page = inject("page");
</script>

<style scoped>
.structurizer-menu {
  list-style-type: none;
  padding-left: 0;
}
</style>
